import { useQuery } from 'react-query';
import { API_ENDPOINT, useJwtToken } from 'helper';
import { useGetIDsFromURL } from 'components/DeviceDetails/helper';
import { useDevice } from 'components/DeviceDetails/service';
import { useUpgradeRecords } from '../service';

export const fetchUpgradeLogs = async ({ Thing_ID, UpdateID }, accessToken) => {
    const url = new URL(
        `${API_ENDPOINT}/devices/${Thing_ID}/upgrade-records/${UpdateID}/logs`
    );
    try {
        const response = await fetch(url.toString(), {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: accessToken,
            },
        });
        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error fetching upgrade logs:', error);
        return null;
    }
};

export const useUpgradeLogs = () => {
    const { Thing_ID, UpdateID } = useGetIDsFromURL();
    const accessToken = useJwtToken();

    return useQuery(
        ['upgradeLogs', Thing_ID, UpdateID],
        () => fetchUpgradeLogs({ Thing_ID, UpdateID }, accessToken),
        {
            enabled: !!Thing_ID && !!UpdateID && !!accessToken,
            staleTime: 60000,
            select: (data) => data?.Items,
        }
    );
};

export const useConfigStatuses = () => {
    const { Thing_ID, UpdateID } = useGetIDsFromURL();
    const { data: device, isLoading: deviceLoading } = useDevice(Thing_ID);
    const { data: upgradeRecord, isLoading: upgradeRecordLoading } =
        useUpgradeRecords();

    const configStatuses = useQuery(
        ['configStatuses', Thing_ID, UpdateID],
        () => {
            let configs = [];
            device?.Config?.data?.MASTER_SNS?.forEach((master) => {
                const lastUpdatedTime = upgradeRecord?.lastUpdatedTime || null;
                configs.push({ ...master, lastUpdatedTime });
                master.PACKS.forEach((pack) => {
                    configs.push({ ...pack, lastUpdatedTime });
                });
            });
            return configs;
        },
        {
            enabled: !!device && !!Thing_ID && !!UpdateID && !!upgradeRecord,
            staleTime: 60000,
        }
    );

    return {
        ...configStatuses,
        isLoading:
            deviceLoading || upgradeRecordLoading
                ? true
                : configStatuses.isLoading,
        upgradeRecord,
    };
};
